import { render, staticRenderFns } from "./FeedbackMain.vue?vue&type=template&id=c882b228&scoped=true&"
import script from "./FeedbackMain.vue?vue&type=script&lang=js&"
export * from "./FeedbackMain.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackMain.vue?vue&type=style&index=0&id=c882b228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c882b228",
  null
  
)

export default component.exports